// extracted by mini-css-extract-plugin
module.exports = {"backgroundCircle":"styles_backgroundCircle__vy9vn","circle":"styles_circle__1cDoR"};